export default {
  TITLE: '=(',
  SUBTITLE: 'Ops! Token inválido.',
  DESCRIPTION: 'Sua sessão é inválida ou já expirou.',
};
